import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import BtnB3 from './BtnB3.js'
import ButtonImageSliced from './ButtonImageSliced.js';

export default class QuestionB3 extends Phaser.GameObjects.Container {
    constructor(scene, data) {
        super(scene, 0, 0, []);

        scene.add.existing(this);
        this.scene = scene;
        this.data = data;
        this.illuData = data.illu
        this.questionContent = data.questionContent
        this.rightAnswer = data.rightAnswer
        this.selectedAnswer = null;

        this.scene.addSounds()

        this.feedBack = data.feedBack

        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });


        this.addBtnBar()
        this.btnContainer.setAlpha(0)

        this.illu = this.scene.add.image(-294, 1088, this.illuData).setOrigin(0.5, 1).setAlpha(1)
        this.add(this.illu);

        this.bulle = this.scene.add.image(1085, 365, "bulle").setOrigin(0.5).setAlpha(0)
        this.add(this.bulle);

        this.questionText = this.scene.add.rexTagText(1085, 365 - 28, this.questionContent, {
            fontSize: "30px",
            fontFamily: "CenturyGothic",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1300 },
            tags: tags
        }).setOrigin(0.5).setAlpha(0);
        this.add(this.questionText);


        let consigne = "Cliquez sur les flèches pour faire défiler les propositions, sélectionnez la bonne et validez votre réponse."
        let consigneX = 525;
        if (this.illuData === "b3MadameTresse") {
            consigneX = 580
        }
        this.consigneText = this.scene.add.rexTagText(consigneX, 720, consigne, {
            fontSize: "20px",
            fontFamily: "CenturyGothicItalic",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1300 },
            tags: tags
        }).setOrigin(0).setAlpha(0);
        this.add(this.consigneText);
        // this.btnContainer.add(this.consigneText);



        this.feedBackText = this.scene.add.rexTagText(580, 740, this.feedBack, {
            fontSize: '24px',
            fontFamily: 'CenturyGothic',
            align: 'left',
            color: Colors.Text.Black,
            wordWrap: { width: 1195 },
            backgroundColor: "transparent",
            tags: tags
        }).setOrigin(0, 0).setAlpha(0);
        this.add(this.feedBackText);

        this.validateBtn = new ButtonImageSliced(this.scene, 1710, 990, 320, 80, "bouton", "Valider").setAlpha(0)
        this.add(this.validateBtn);
        this.validateBtn.setLocked()
        this.validateBtn.setClickFunction(() => {
            this.scene.nextBtn.setAlpha(1);
            this.allBtns.forEach(btn => btn.disableInteractive());
            this.leftArrow.disableInteractive();
            this.rightArrow.disableInteractive();
            this.validationMecanism()
            this.consigneText.setAlpha(0);
            this.validateBtn.setAlpha(0);
            this.feedBackText.setAlpha(1);

        })

        this.launchAnimation()
    }

    addBtnBar() {
        // this.scene.allAnswers = Phaser.Utils.Array.Shuffle(this.scene.allAnswers);
        this.allBtns = [];
        this.btnContainer = this.scene.add.container(580, 600)
        this.add(this.btnContainer);
        this.btnSpacing = 360;
        this.visibleBtnCount = 3;
        this.scene.allAnswers.forEach((answer, index) => {
            const btn = new BtnB3(this.scene, 0 + index * this.btnSpacing, 0, answer, this);
            this.btnContainer.add(btn);
            this.allBtns.push(btn);
        });

        this.rectLeft = this.scene.add.rexRoundRectangle(0, 580, 565, 120, 0, Colors.Elmt.White).setOrigin(0)
        this.add(this.rectLeft);
        // this.btnContainer.add(this.rectLeft);

        this.rectRight = this.scene.add.rexRoundRectangle(1745, 580, 180, 120, 0, Colors.Elmt.White).setOrigin(0)
        this.add(this.rectRight);
        // this.btnContainer.add(this.rectRight);

        this.leftArrow = this.scene.add.image(525, 640, "arrowLeftB3").setOrigin(0.5).setAlpha(0);
        this.add(this.leftArrow);
        // this.btnContainer.add(this.leftArrow);
        this.rightArrow = this.scene.add.image(1785, 640, "arrowRightB3").setOrigin(0.5).setAlpha(0);
        this.add(this.rightArrow);
        // this.btnContainer.add(this.rightArrow);

        this.leftArrow.setSize(this.leftArrow.width, this.leftArrow.height);
        this.leftArrow.setInteractive({ useHandCursor: true });
        this.leftArrow.on('pointerdown', () => {
            this.clickSound.play();
            // if (this.btnContainer.x <= 570) {
            //     this.btnContainer.x += 360;
            // }
            this.shiftCarousel(-1);
        })

        this.rightArrow.setSize(this.rightArrow.width, this.rightArrow.height);
        this.rightArrow.setInteractive({ useHandCursor: true });
        this.rightArrow.on('pointerdown', () => {
            this.clickSound.play();

            // if (this.btnContainer.x >= -580) {
            //     this.btnContainer.x -= 360;
            // }
            this.shiftCarousel(1);
        })
    }

    shiftCarousel(direction) {
        const moveAmount = direction * this.btnSpacing;

        this.btnContainer.iterate(btn => {
            btn.x -= moveAmount;
        });

        // Recyclage
        if (direction === 1) {
            // Bouton qui sort à gauche → replacer à droite
            const leftMost = this.allBtns.reduce((a, b) => a.x < b.x ? a : b);
            const rightMost = this.allBtns.reduce((a, b) => a.x > b.x ? a : b);

            if (leftMost.x < -this.btnSpacing * 1.5) {
                leftMost.x = rightMost.x + this.btnSpacing;
            }
        } else {
            // Bouton qui sort à droite → replacer à gauche
            const leftMost = this.allBtns.reduce((a, b) => a.x < b.x ? a : b);
            const rightMost = this.allBtns.reduce((a, b) => a.x > b.x ? a : b);

            if (rightMost.x > this.btnSpacing * (this.visibleBtnCount + 0.5)) {
                rightMost.x = leftMost.x - this.btnSpacing;
            }
        }
    }


    validationMecanism() {

        const isValid = this.rightAnswer === this.selectedAnswer.index;
        if (isValid) {
            this.scene.playSound('win');
            this.selectedAnswer.setGood();
            this.scene.tweens.add({
                targets: this.selectedAnswer,
                x: 300,
                // x: 1180,
                duration: 300,
                ease: 'Power2'
            });
            this.allDesapearedBtns = this.allBtns.filter(btn => btn !== this.selectedAnswer);
            this.allDesapearedBtns.push(this.leftArrow, this.rightArrow);
            console.log("this.allDesapearedBtns", this.allDesapearedBtns)
            this.scene.tweens.add({
                targets: this.allDesapearedBtns,
                alpha: 0,
                // x: 1180,
                duration: 300,
                ease: 'Power2'
            });

        } else {
            this.correctAnswer = undefined
            this.selectedAnswer.setWrong();
            this.scene.playSound('lose');
            this.allBtns.forEach(btn => {
                if (btn.index === this.rightAnswer) {
                    btn.setGood();
                    this.correctAnswer = btn;
                }
            })
            this.scene.tweens.add({
                targets: this.selectedAnswer,
                x: 100,
                // x: 1180,
                duration: 300,
                ease: 'Power2'
            });
            this.scene.tweens.add({
                targets: this.correctAnswer,
                x: 500,
                // x: 1180,
                duration: 300,
                ease: 'Power2'
            });
            this.allDesapearedBtns = this.allBtns.filter(btn => btn !== this.selectedAnswer);
            this.allDesapearedBtns = this.allDesapearedBtns.filter(btn => btn !== this.correctAnswer);
            this.allDesapearedBtns.push(this.leftArrow, this.rightArrow);
            console.log("this.allDesapearedBtns", this.allDesapearedBtns)
            this.scene.tweens.add({
                targets: this.allDesapearedBtns,
                alpha: 0,
                // x: 1180,
                duration: 300,
                ease: 'Power2'
            });


        }
    }

    launchAnimation() {
        this.scene.tweens.add({
            targets: this.illu,
            x: 294,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: [this.bulle, this.questionText],
                    alpha: 1,
                    duration: 300,
                    ease: 'Power2',
                    onComplete: () => {
                        this.scene.tweens.add({
                            targets: [this.btnContainer, this.leftArrow, this.rightArrow, this.consigneText],
                            alpha: 1,
                            duration: 300,
                            ease: 'Power2'
                        })
                        this.scene.tweens.add({
                            targets: this.validateBtn,
                            alpha: 0.5,
                            duration: 300,
                            ease: 'Power2',
                            onComplete: () => {
                                this.validateBtn.setLocked()

                            }
                        })
                    }
                })
            }
        })

    }

    launchNext() {

        this.scene.tweens.add({
            targets: [this.bulle, this.questionText, this.btnContainer, this.validateBtn, this.leftArrow, this.rightArrow, this.feedBackText],
            alpha: 0,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.illu,
                    x: -294,
                    duration: 300,
                    ease: 'Power2',
                    onComplete: () => {
                        this.setAlpha(0)
                        if (this.scene.level <= 5) {
                            this.scene.level++
                            this.scene.y = this.scene.launchQuestion(this.scene.allQuestions[this.scene.level]);
                        } else {
                            this.scene.launchEndScreen()
                        }

                    }
                })

            }
        })


    }

}
